


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({})
export default class RightPanel extends Vue {
  @Prop({ default: true })
  closeOnClickMask!: Boolean;

  @Prop({ default: 50 })
  bottom!: Number;

  @Prop({ default: "el-icon-setting" })
  icon!: string;

  @Prop({ default: false })
  inner!: Boolean;

  show = false;
  @Watch("show")
  showChange(value) {
    if (value && this.closeOnClickMask) {
      this.addEventClick();
    }
    if (value) {
      this.addClass(document.body, "showRightPanel");
    } else {
      this.removeClass(document.body, "showRightPanel");
    }
  }
  mounted() {
   // this.insertToBody();
  }
  beforeDestroy() {
    const elx = this.$refs.rightPanel as any;
    elx.remove();
  }
  addEventClick() {
    window.addEventListener("click", this.closeSidebar);
  }
  closeSidebar(evt) {
    const parent = evt.target.closest("." + this["$style"]["rightPanel"]);
    if (!parent) {
      this.show = false;
      window.removeEventListener("click", this.closeSidebar);
    }
  }
  insertToBody() {
    const elx = this.$refs.rightPanel;
    const body = document.querySelector("body") as any;
    body.insertBefore(elx, body.firstChild);
  }

  hasClass(ele, cls) {
    return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
  }

  addClass(ele, cls) {
    if (!this.hasClass(ele, cls)) ele.className += " " + cls;
  }

  removeClass(ele, cls) {
    if (this.hasClass(ele, cls)) {
      const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
      ele.className = ele.className.replace(reg, " ");
    }
  }
}
